import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import Request from '../services/request'

const MetadataAndConfig = createContext({})

export const MetadataAndConfigProvider = ({ children }) => {
  const [metadata, setMetadata] = useState({})

  const getMetadata = () => {
    Request.send({
      method: 'POST',
      path: '/SystemConfigurations/getMetadata',
      data: null,
      query: {} // apiKey sẽ tự inject trong send()
    }).then((res) => {
      if (res?.statusCode === 200) {
        setMetadata(res.data || {})
      }
    })
  }

  useEffect(() => {
    getMetadata()
  }, [])

  const STATION_TYPE = useMemo(() => {
    if (metadata?.STATION_TYPE_OBJECTS) {
      return Object.values(metadata.STATION_TYPE_OBJECTS).map((item) => ({
        label: item.stationTypeName,
        value: item.stationType,
      }))
    }
    return []
  }, [metadata])

  return (
    <MetadataAndConfig.Provider value={{ metadata, STATION_TYPE }}>
      {children}
    </MetadataAndConfig.Provider>
  )
}

export const useMetadataAndConfig = () => useContext(MetadataAndConfig)